export default "__VITE_ASSET__Do6Ta29C__"